import React from "react";
import { useHits, useInstantSearch } from "react-instantsearch";
import { useSearchPageContext } from "../../components/pages/SearchPage/SearchPageContext";
import { useMyCollections } from "../../contexts/MyCollectionsContext/MyCollectionsContext";
import Events from "../analytics";
import { Hit, ListingCardData, mapHitToListing } from "./mapHitToListing";
import ListingCard from "../../components/composites/v2/ListingCard/ListingCard";
import styled from "styled-components";
import Box from "../../components/elements/v2/Box/Box";
import { breakpoints } from "../styledHelpers";
import LongTailPage from "../../components/pages/SearchPage/components/LongTailPage";

export default function Hits() {
  const { myCountry, myCurrency, collectionId } = useSearchPageContext();
  const { allCollectionListingIds } = useMyCollections();
  const { items, sendEvent } = useHits<Hit>();
  const { status } = useInstantSearch();

  const listingCardLocation = collectionId ? "Collection" : "Search";
  const searching = status === "loading" || status === "stalled";

  const handleItemClick = (item: Hit, listing: ListingCardData, listingCardLocation: string) => {
    sendEvent("click", item, "Hit Clicked");
    Events.sendProductCardClicked(listing, listingCardLocation);
  };

  const onItemWishList = (item: Hit) => {
    sendEvent("conversion", item, "Item Added to Wishlist");
  };

  return (
    <Container $searching={searching} className="t-searchResults">
      {items.length ? (
        items.map((item) => {
          const listing = mapHitToListing(item, allCollectionListingIds, myCurrency);

          return (
            <ListingCard
              key={item.objectID}
              listing={listing}
              handleClick={() => handleItemClick(item, listing, listingCardLocation)}
              onItemWishList={() => onItemWishList(item)}
              countryCode={myCountry?.code}
            />
          );
        })
      ) : (
        <p>No results found.</p>
      )}
      <LongTailPage items={items} clickHandler={handleItemClick} />
    </Container>
  );
}

const Container = styled(Box)<{ $searching?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 30px;
  padding: 20px;
  ${({ $searching }) => $searching && `opacity: 0.5;`}
  ${breakpoints.down("md")} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  ${breakpoints.down("sm")} {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    padding: 10px;
    grid-column-gap: 10px;
    grid-row-gap: 20px;
  }
`;
